import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { getTwitchOAuth, validationDataSelector } from 'src/store/auth';

import { ROUTE } from 'src/constants';
import { CustomButton } from 'src/components';
import { LanguageSwitcher } from 'src/features/landing/components';

import { TwitchOutlined } from '@ant-design/icons';
// import Logo from 'src/assets/logo.webp';
import { Logo192 } from 'src/assets';
import './header.scss';

export const Header = () => {
  const { t } = useTranslation('header');

  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const validationData = useSelector(validationDataSelector);

  const [redirectTo, setRedirectTo] = useState(ROUTE.MAIN);

  const hiddenButtonList = [ROUTE.AUTH.TWITCH_CALLBACK, ROUTE.DASHBOARD.MAIN];
  const isVisibleButton = !hiddenButtonList.includes(pathname);

  useEffect(() => {
    if (!validationData?.status) {
      setRedirectTo(ROUTE.MAIN);
    }

    if (validationData?.status) {
      setRedirectTo(ROUTE.DASHBOARD.MAIN);
    }
  }, [validationData]);

  const onClickConnect = useCallback(() => {
    dispatch(getTwitchOAuth());
  }, [dispatch]);

  return (
    <header className="header">
      <div className="header__content">
        <Link className="header__logo" to={redirectTo}>
          {/* <img src={Logo} alt={Logo} width={200} /> */}
          <img className="ant-layout__logo" src={Logo192} alt="Logo" />
          <h3>BOT</h3>
        </Link>

        <div className="header__actions">
          <LanguageSwitcher className="header__language-switcher" />

          {isVisibleButton && !validationData?.status ? (
            <CustomButton
              title={t('login')}
              onClick={onClickConnect}
              icon={TwitchOutlined}
              iconPosition="right"
            />
          ) : null}

          {isVisibleButton && validationData?.status ? (
            <CustomButton title={t('dashboard')} component="link" to={ROUTE.DASHBOARD.MAIN} />
          ) : null}
        </div>
      </div>
    </header>
  );
};
